export default {
    // "api_url": "http://localhost:7071/",
    "api_url": "https://epiwatch-api.azurewebsites.net/",
    "recaptchaSiteKey": "6LeXfZUcAAAAAIbuyKbg52VkrHyS0XMbcpjMQXz8"
}
